import facebookIcon from "./icon-facebook-alt.svg"
import feedIcon from "./icon-feed-alt.svg"
import linkedinIcon from "./icon-linkedin-alt.svg"
import redditIcon from "./icon-reddit-alt.png"
import twitterIcon from "./icon-twitter-alt.svg"
import * as css from "./SocialShare.module.css"

export default function index({ title }) {
  const link = typeof window === "undefined" ? "" : window.location.href
  const encodedLink = encodeURIComponent(link)
  const encodedTitle = encodeURIComponent(title)

  const linkedinLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedLink}&title=${encodedTitle}`
  const twitterLink = `https://twitter.com/intent/tweet?url=${encodedLink}&text=${encodedTitle}`
  const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodedLink}&quote=${encodedTitle}`
  const redditLink = `https://www.reddit.com/submit?url=${encodedLink}&title=${encodedTitle}`
  const rssFeedLink = `https://preset.io/rss.xml`

  return (
    <div className={css.container}>
      <a
        className={css.socialIcon}
        href={linkedinLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={linkedinIcon} alt="Linkedin" />
      </a>
      <a
        className={css.socialIcon}
        href={twitterLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={twitterIcon} alt="Twitter" />
      </a>
      <a
        className={css.socialIcon}
        href={facebookLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={facebookIcon} alt="Facebook" />
      </a>
      <a
        className={css.socialIcon}
        href={redditLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={redditIcon} alt="Reddit" />
      </a>
      <a
        className={css.socialIcon}
        href={rssFeedLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={feedIcon} alt="RSS Feed" />
      </a>
    </div>
  )
}
